import validate from "/home/ubuntu/prod_craftstory_temp/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/ubuntu/prod_craftstory_temp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  validated2: () => import("/home/ubuntu/prod_craftstory_temp/src/domains/dashboard/middleware/validated2.ts"),
  auth: () => import("/home/ubuntu/prod_craftstory_temp/src/middleware/auth.ts"),
  "to-projects": () => import("/home/ubuntu/prod_craftstory_temp/src/middleware/to-projects.ts")
}